import Icon from "../icon/icon";
import React from "react";

export interface ISearchClearProps {
  onMouseEnter: React.MouseEventHandler<HTMLButtonElement>;
  onMouseLeave: React.MouseEventHandler<HTMLButtonElement>;
  onClick: () => void;
  isMobile?: boolean;
}

function SearchClear(props: ISearchClearProps) {
  return (
    <button
      className={props.isMobile ? "search-clear-mobile " : "search-clear"}
      type="button"
      onClick={() => {
        props.onClick();
      }}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <Icon className="d-block">close</Icon>
    </button>
  );
}

export default SearchClear;
